<div class="workflow-container">
  <i style="display: none;">{{changeCounter}}</i>
  <svg #workflowSvg height="250">
    <!-- The SVG elements will be added dynamically -->
  </svg>
</div>
